// Types
import type { NotificationSubscriptionProps } from '@/utils/hooks/context/toast/types';

// Component
import Notification from '@/components/base/Notification';

// Routes
import { SUBSCRIPTION_INVOICES } from '@/routes/privateRoutes';

const OptionsCancellationEffective = ({ notification }: NotificationSubscriptionProps) => {
    const addonsList: { number: number; addonname: string }[] = Object.values(
        notification?.data?.options ?? []
    );
    const numberOthersAddons = addonsList.reduce(
        (accumulator, addon, index) => (index > 0 ? accumulator + addon.number : accumulator),
        0
    );

    return (
        <Notification
            dataNotification={notification}
            goToUrl={SUBSCRIPTION_INVOICES}
            contentHidden={notification?.options?.hideContent ?? false}
            wide={notification?.options?.wide ?? true}>
            <Notification.Icon icon="paid-data" />
            <Notification.Content>
                <Notification.Title i18nKey="commons:notifications.options_cancellation_effective.title" />
                <Notification.Description
                    i18nKey={
                        numberOthersAddons > 0
                            ? 'commons:notifications.options_cancellation_effective.description_multiple_addons'
                            : 'commons:notifications.options_cancellation_effective.description_single_addon'
                    }
                    values={{
                        number: addonsList?.[0]?.number,
                        addon_name: addonsList?.[0]?.addonname,
                        number_others: numberOthersAddons
                    }}
                />
            </Notification.Content>
        </Notification>
    );
};

export default OptionsCancellationEffective;
